import {handleLogout} from "components/utils";
import React, {useEffect, useState} from 'react';
import {Button, Col, Form, Row, Table} from "react-bootstrap";
import axios from "axios";
import {SERVICES} from "../permissions";
import {
    DatatableWrapper,
    Filter,
    Pagination,
    PaginationOptions, TableBody,
    TableColumnType,
    TableHeader
} from "react-bs-datatable";
import Editor from "react-simple-wysiwyg";
import {RichEditor} from "../ipd/consentForms/RichEditor";

export const AddDiagnosticServicesTemplateView = (props: { cookieEntityQr: string, category: string, postAction: any }) => {
    const [errorMessage, setErrorMessage] = useState(null);
    const [parameters, setParameters] = useState([]);
    const [notes, setNotes] = useState(null);
    const [addParam, setAddParam] = useState({});
    const [testName, setTestName] = useState<string>();
    const [testType, setTestType] = useState<string>();


    const handleRemove = (index) => {
        setErrorMessage("")
        parameters.splice(index, 1)
    }

    const handleAdd = () => {
        setParameters([...parameters, addParam])
        setAddParam({})
    }

    const handleSave = () => {
        setErrorMessage("")
        parameters.forEach(p => {
            p["entityQr"] = props.cookieEntityQr
            p["type"] = "system"
            p["paramType"] = "VARIABLE"
        })
        axios.post('/api/backend/templates/create', {
            params: [...parameters, {
                entityQr: props.cookieEntityQr,
                name: "Notes",
                type: "system",
                paramType: "CONSTANT",
                description: notes
            }],
            qr: props.cookieEntityQr,
            category: props.category,
            subCategory: testType,
            name: testName
        })
            .then(resp => {
                console.log(resp.data)
                props.postAction()
            })
            .catch(err => {
                console.error(err);
                if (err.response && err.response!.status && err.response!.status === 403) {
                    handleLogout()
                }
                setErrorMessage("* Something went wrong!")
            })
    }

    const handleChange = (e) => {
        var bioref = null
        if (e.target.name == "rangeStart") {
            if (addParam["rangeEnd"]) {
                bioref = e.target.value + " - " + addParam["rangeEnd"]
            } else {
                bioref = ">= " + e.target.value
            }
        }
        if (e.target.name == "rangeEnd") {
            if (addParam["rangeStart"]) {
                bioref = addParam["rangeStart"] + " - " + e.target.value
            } else {
                bioref = "<= " + e.target.value
            }
        }
        if (bioref) {
            setAddParam({
                ...addParam,
                [e.target.name]: e.target.value,
                bioReference: bioref
            });
        } else {
            setAddParam({
                ...addParam,
                [e.target.name]: e.target.value,
            });
        }
    };


    return (
        <div className="min-vh-100">
            <Form.Label className="text-info">Test name:</Form.Label>
            <input className="form-control form-control-sm" value={testName}
                   onChange={e => setTestName(e.target.value)}/>

            <Form.Label className="text-info mt-4">Test type:</Form.Label>
            <input className="form-control form-control-sm" value={testType}
                   onChange={e => setTestType(e.target.value)} placeholder="Eg. Blood Test, Urine Test etc."/>

            <Form.Label className="text-info mt-4">Test Parameters:</Form.Label>
            <table className="table">
                <thead>
                <th>Parameter Name</th>
                <th>Units</th>
                <th>Range Start</th>
                <th>Range End</th>
                <th>bioReference</th>
                <th>Action</th>
                </thead>
                <tbody>
                {parameters && parameters.map(p => {
                    return <tr key={p.id}>
                        <td>
                            {p.name}
                        </td>
                        <td>
                            {p.units}
                        </td>
                        <td>
                            {p.rangeStart}
                        </td>
                        <td>
                            {p.rangeEnd}
                        </td>
                        <td>
                            {p.bioReference}
                        </td>
                        <td>
                            {p.entityQr != "system" && <a href="#/" className="remove text-decoration-none"
                                                          onClick={() => handleRemove(p.id)}>X</a>}
                        </td>
                    </tr>
                })}
                <tr>
                    <td>
                        <input className="form-control form-control-sm" name="name"
                               value={addParam["name"] ? addParam["name"] : ""}
                               onChange={e => handleChange(e)}/>
                    </td>
                    <td>
                        <input className="form-control form-control-sm" name="units"
                               value={addParam["units"] ? addParam["units"] : ""} onChange={e => handleChange(e)}/>
                    </td>
                    <td>
                        <input className="form-control form-control-sm" name="rangeStart"
                               value={addParam["rangeStart"] ? addParam["rangeStart"] : ""}
                               onChange={e => handleChange(e)}/>
                    </td>
                    <td>
                        <input className="form-control form-control-sm" name="rangeEnd"
                               value={addParam["rangeEnd"] ? addParam["rangeEnd"] : ""}
                               onChange={e => handleChange(e)}/>
                    </td>
                    <td>
                        <input className="form-control form-control-sm" name="bioReference"
                               value={addParam["bioReference"] ? addParam["bioReference"] : ""}
                               onChange={e => handleChange(e)}/>
                    </td>
                    <td>
                        <button className="btn btn-sm btn-warning text-white" onClick={() => handleAdd()}>+ Add</button>
                    </td>
                </tr>
                </tbody>
            </table>
            <Form.Group controlId="notes">
                <Editor
                    containerProps={{style: {resize: 'vertical', minHeight: "200px"}}}
                    value={notes}
                    onChange={e => setNotes(e.target.value)}
                    placeholder="Write Notes to be printed on all reports"
                />
            </Form.Group>

            <br/>
            <button className="btn btn-warning text-white"
                    onClick={() => handleSave()}>Save
            </button>

            {errorMessage &&
                <div className="text-danger fs-5">{errorMessage}</div>
            }

        </div>
    );
};
